//Functions needed to copy  list of songs

$( document ).ready(function() {

const $list = $('#tag-songs-list');
if ($list.length > 0){

    let scrollable = true;
    const windowHeight = $( window ).height();
    const closeToTopEdge = 0.1 * windowHeight;
    const closeToBottomEdge = windowHeight - closeToTopEdge;

  $('#searchList .searchItem').on('click', (e)=>{
    const $this = $(e.currentTarget);
    addToList($this.data('song-id'), $this.data('song-duration'));
    setSongsOrder();
  });

  $('.remove', $list).on('click', (e)=>{
    const $this = $(e.currentTarget);
    removeFromList($this.data('song-id'), $this.data('song-duration'));
    setSongsOrder()
  });
}


function setSongsOrder(){
    const $songs = $('.selectedSongs', $list);
    let itemOrder = 0;
    $songs.each((i, song) => {
        const $song = $(song);
        if(!$song.hasClass('d-none')){
            itemOrder += 1;
            $('.song-order-input input', $song).val(itemOrder);
            $('.song-order', $song).text(itemOrder);
        }
    });
}



function clearPastSelect() {
    document.getElementById("previous").options[0].selected = 'selected';
}

function clearFutureSelect() {
    document.getElementById("future").options[0].selected = 'selected';
}


//Functions needed for creating list manually

function convertToSeconds(duration) {
    if (duration != "None") {
        let secs_to_add = parseInt(duration.slice(-2));

        let mins_to_add = parseInt(duration.substr(-5, 2));
        secs_to_add += (mins_to_add * 60);

        let hours_to_add = parseInt(duration.substr(-8, 2));
        secs_to_add += (hours_to_add * 60 * 60)

        return secs_to_add
    }
}

function addToList(song_id, duration){
    const $addedSong = $('#selectedSongs-' + song_id);
    $addedSong
        .appendTo($addedSong.parent())
        .removeClass('d-none')
    ;

    var checkBox_to_search = "checkbox-" + song_id;
    document.getElementById(checkBox_to_search).checked = true;

    //  before counting times we have to define these variables,
    //  and then, after counting, we have to change class
    var song_to_mark_checked = "SongList-" + song_id;
    var song_on_the_list = document.getElementById(song_to_mark_checked);

//    finally, we have to make selected song green on the list
    song_on_the_list.classList.add("selected");
}


function removeFromList(song_id){
    var class_to_search = "selectedSongs-" + song_id;
    document.getElementById(class_to_search).classList.add("d-none");

    var checkBox_to_search = "checkbox-" + song_id;
    document.getElementById(checkBox_to_search).checked = false;

    var song_to_mark_checked = "SongList-" + song_id;
    var song_on_the_list = document.getElementById(song_to_mark_checked);

    song_on_the_list.classList.remove("selected");
}

});